import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareTypeService {

  constructor() { }
  
  private SEdMode = new BehaviorSubject<boolean>(false);
  SEMode$ = this.SEdMode.asObservable();

  SEditMode(value: boolean): void {
    this.SEdMode.next(value);
  }

}
